import type { FC } from 'react';

import Image from 'next/image';

import { Typography } from '@gds/Typography/Typography';
import { getFormattedDate } from '@intl/GetFormattedDate';

import type { ArticleCardData } from './ArticleCard.types';

import styles from './ArticleCard.module.css';

type Props = {
  article: ArticleCardData;
  linkPrefix?: string;
};

const ArticleCard: FC<Props> = ({ article, linkPrefix }) => {
  const { slug, heading, subheading, thumbnailImage, createdAt } = article;
  const getDate = createdAt ? new Date(createdAt) : null;
  const formattedDate = getDate && getFormattedDate(getDate);
  return (
    <a href={`${linkPrefix}${slug}`} className={styles.articleCard}>
      <div className={styles.imageWrapper}>
        <Image
          src={thumbnailImage.url}
          alt={thumbnailImage.description || ''}
          fill
          sizes="(min-width: 1024px) 33vw, 100vw"
          className={styles.image}
        />
      </div>

      {formattedDate && (
        <Typography variant="body4" className={styles.date}>
          {formattedDate}
        </Typography>
      )}

      <Typography className={styles.title} variant="h5" Component={`h3`}>
        {heading}
      </Typography>

      {subheading && <Typography className={styles.subtitle}>{subheading}</Typography>}
    </a>
  );
};

export { ArticleCard };
